import { useState, useEffect } from 'react'
import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Fade } from '../ui/Fade'

const REVS = [
  { q: 'Подобрал всё оборудование онлайн за 20 минут. Привезли точно в срок - без лишних звонков и согласований.',         n: 'Арман Т.',    role: 'Прораб',              r: 'Алматы',     a: '#0A7B86', st: 5 },
  { q: 'Конфигуратор сам посчитал объём и предложил нужный насос. Установили - работает отлично уже второй сезон.',          n: 'Динара К.',   role: 'Частный клиент',      r: 'Алматы',     a: '#0F3B4F', st: 5 },
  { q: 'Скачал PDF со спецификацией и передал монтажникам - сразу поняли что заказывать. Сэкономил минимум две недели.',     n: 'Сергей В.',   role: 'Застройщик',          r: 'Бесагаш',    a: '#0A6E8C', st: 4 },
  { q: 'Бесплатная консультация реально помогла - объяснили разницу между насосами и порекомендовали оптимальный вариант.',  n: 'Асхат М.',    role: 'Частный клиент',      r: 'Алматы',     a: '#073B41', st: 5 },
  { q: '3D-вид убедил что всё встанет правильно. Смонтировали без единой проблемы, всё в срок.',                            n: 'Марина Л.',   role: 'Дизайнер интерьеров', r: 'Нур-Султан', a: '#0A3B55', st: 5 },
  { q: 'Цены честные, никаких скрытых расходов. Менеджер был на связи на каждом этапе. Определённо рекомендую.',            n: 'Руслан Б.',   role: 'Владелец коттеджа',   r: 'Алматы',     a: '#0D2240', st: 5 },
]

function StarIcon({ filled, half }) {
  if (half) return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ display: 'block', flexShrink: 0 }}>
      <defs>
        <linearGradient id="halfStar"><stop offset="50%" stopColor="#F5A623"/><stop offset="50%" stopColor="#e0e0e0"/></linearGradient>
      </defs>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#halfStar)"/>
    </svg>
  )
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill={filled ? '#F5A623' : '#E5E7EB'} style={{ display: 'block', flexShrink: 0 }}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  )
}

function Stars({ count }) {
  return (
    <div style={{ display: 'flex', gap: 2 }}>
      {[1,2,3,4,5].map(i => (
        <StarIcon key={i} filled={i <= Math.floor(count)} half={count % 1 !== 0 && i === Math.ceil(count)}/>
      ))}
    </div>
  )
}

function ChevronLeft() {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
      <path d="M8 2L2 8l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

function ChevronRight() {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
      <path d="M2 2l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

function RevCard({ r, i }) {
  return (
    <div className="card-l" style={{ padding: 24, animation: 'fadeUp .45s ease both', animationDelay: `${i * 60}ms`, display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Quote mark */}
      <div style={{ fontSize: 48, lineHeight: 1, color: 'rgba(10,123,134,.12)', fontFamily: 'Georgia,serif', fontWeight: 900, marginBottom: 2, marginTop: -8, marginLeft: -4 }}>"</div>

      <div style={{ display: 'flex', gap: 3, marginBottom: 12 }}>
        <Stars count={r.st}/>
      </div>

      <p style={{ fontSize: 14.5, lineHeight: 1.67, color: C.ink2, flex: 1, marginBottom: 18 }}>{r.q}</p>

      <div style={{ display: 'flex', alignItems: 'center', gap: 11, paddingTop: 14, borderTop: '1px solid rgba(10,32,40,.06)' }}>
        <div style={{ width: 40, height: 40, borderRadius: '50%', background: `linear-gradient(135deg,${r.a},${r.a}cc)`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: `0 4px 14px ${r.a}44` }}>
          <span style={{ fontSize: 15, fontWeight: 800, color: '#fff' }}>{r.n[0]}</span>
        </div>
        <div>
          <b style={{ display: 'block', fontSize: 14, color: C.ink, lineHeight: 1.2 }}>{r.n}</b>
          <span style={{ fontSize: 11.5, color: C.muted, lineHeight: 1.4 }}>{r.role} · {r.r}</span>
        </div>
      </div>
    </div>
  )
}

export default function Reviews() {
  const [page,    setPage]    = useState(0)
  const [perPage, setPerPage] = useState(3)

  useEffect(() => {
    const upd = () => {
      const w = window.innerWidth
      setPerPage(w < 560 ? 1 : w < 820 ? 2 : 3)
    }
    upd()
    window.addEventListener('resize', upd)
    return () => window.removeEventListener('resize', upd)
  }, [])

  useEffect(() => { setPage(0) }, [perPage])

  const pages   = Math.ceil(REVS.length / perPage)
  const visible = REVS.slice(page * perPage, (page + 1) * perPage)

  const dots = Array.from({ length: pages }).map((_, i) => (
    <button
      key={i}
      onClick={() => setPage(i)}
      aria-label={`Страница отзывов ${i + 1}`}
      style={{ width: i === page ? 24 : 8, height: 8, borderRadius: 4, border: 'none', background: i === page ? C.teal : 'rgba(10,32,40,.14)', cursor: 'pointer', transition: 'all .3s' }}
    />
  ))

  return (
    <section className="sec" style={{ background: C.paper2 }}>
      <div className="wrap">
        <Fade className="sec-head">
          <span className="eb light">ОТЗЫВЫ</span>
          <h2 className="chrome-ink" style={{ fontSize: 'clamp(26px,3.5vw,42px)', marginTop: 16 }}>
            Клиенты, которые выбрали Welland
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 12 }}>
            <Stars count={5}/>
            <span style={{ fontSize: 14, color: C.muted }}>5.0 · {REVS.length} отзывов</span>
          </div>
        </Fade>

        <Fade>
          <div className="rev-outer">
            <div className="rev-sidenav-wrap" style={{ display: 'flex', flexShrink: 0 }}>
              <button className="rev-sidenav" aria-label="Предыдущие отзывы" onClick={() => setPage(p => (p - 1 + pages) % pages)}>
                <ChevronLeft/>
              </button>
            </div>
            <div className="rev-grid">
              {visible.map((r, i) => <RevCard key={`${page}-${i}`} r={r} i={i}/>)}
            </div>
            <div className="rev-sidenav-wrap" style={{ display: 'flex', flexShrink: 0 }}>
              <button className="rev-sidenav" aria-label="Следующие отзывы" onClick={() => setPage(p => (p + 1) % pages)}>
                <ChevronRight/>
              </button>
            </div>
          </div>
          <div className="rev-dotsrow">{dots}</div>
          <div className="rev-botnav">
            <button className="rev-botnav-btn" aria-label="Назад" onClick={() => setPage(p => (p - 1 + pages) % pages)}><ChevronLeft/></button>
            <div style={{ display: 'flex', gap: 6 }}>{dots}</div>
            <button className="rev-botnav-btn" aria-label="Вперёд" onClick={() => setPage(p => (p + 1) % pages)}><ChevronRight/></button>
          </div>
        </Fade>
      </div>
    </section>
  )
}
